import { useState } from 'react';
import { api } from '../../lib/api';
import { Modal } from '../../components/primitives';

// ── Change password modal ─────────────────────────────────────────────────

export function ChangePasswordModal({
  totpEnabled,
  onClose,
  onDone,
}: {
  totpEnabled: boolean;
  onClose: () => void;
  onDone: () => void;
}) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const valid = current.length > 0 && next.length >= 8 && (!totpEnabled || code.length >= 6);

  const submit = async () => {
    if (!valid || busy) return;
    setBusy(true);
    setError(null);
    try {
      await api('/api/auth/change-password', {
        method: 'POST',
        json: { current_password: current, new_password: next, code: code || undefined },
      });
      onDone();
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Change failed.');
      setBusy(false);
    }
  };

  return (
    <Modal
      title="Change password"
      mobile="half"
      context="SETTINGS"
      width={520}
      onClose={onClose}
      hint="At least 8 characters"
      foot={
        <>
          <button className="btn" onClick={onClose}>
            Cancel
          </button>
          <button className="btn primary" onClick={submit} disabled={!valid || busy}>
            Change password →
          </button>
        </>
      }
    >
      <div className="form-grid">
        <div className="f-field span-2">
          <span className="f-label">
            Current password <span className="req">*</span>
          </span>
          <input
            className="f-input"
            type="password"
            value={current}
            aria-label="Current password"
            autoComplete="current-password"
            onChange={(e) => setCurrent(e.target.value)}
            autoFocus
          />
        </div>
        <div className="f-field span-2">
          <span className="f-label">
            New password <span className="req">*</span>
          </span>
          <input className="f-input" type="password" aria-label="New password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} />
        </div>
        {totpEnabled && (
          <div className="f-field">
            <span className="f-label">
              TOTP code <span className="req">*</span>
            </span>
            <input
              className="f-input mono"
              inputMode="numeric"
              placeholder="123456"
              value={code}
              aria-label="TOTP code"
              autoComplete="one-time-code"
              onChange={(e) => setCode(e.target.value)}
            />
          </div>
        )}
        {error && <p className="error-text span-2">{error}</p>}
      </div>
    </Modal>
  );
}
